<template>
  <div>
    Working
    {{posts}}
  </div>
</template>

<script>
import { HTTP } from "../https-common";

export default {
  name: "Test",
  created() {
    this.getRoles();
  },
  methods: {
    getRoles() {
      HTTP.get(`/roles/tenant`)
        .then(response => {
          this.posts = response.data;
        })
        .catch(e => {
          console.log(e)
          this.errors.push(e);
        });
    },

    addRole(roleName) {
      HTTP.post("/roles", {
        'name': roleName
      })
        .then(reposnse => {
          console.log(reposnse);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  data() {
    return {
      reposnse: "",
      posts: [],
      errors: []
    };
  }
};
</script>

<style>
</style>